/*
 * @Descripttion: 
 * @version: 
 * @Author: bbq
 * @Date: 2020-08-17 09:56:40
 * @LastEditors: bbq
 * @LastEditTime: 2020-12-14 15:11:28
 */
import React, { Component } from 'react';
import classnames from 'classnames';
import Tooltip from '../Tooltip';
import { getMultiLang } from '@platform/api';

require('./index.less');

export default class RefreshBtn extends Component {
    constructor(props) {
        super(props);
        this.state = { langJson: {} };
    }

    UNSAFE_componentWillMount() {
        let callback = langJson => {
            this.setState({ langJson });
        };
        // moduleId为所需加载langJson文件夹名称前缀
        getMultiLang({ moduleId: 'common_icon_title', callback });
    }

    render() {
        let { langJson } = this.state;
        let { onClick, className = '', tooltip = langJson['icon-refresh'], disabled = false, ...others } = this.props;
        let refreshClass = classnames({
            'refresh-btn-disabled': disabled,
            'refresh-btn iconfont icon icon-shuaxin1': true
        });
        return (
            <Tooltip
                placement="top"
                overlay={tooltip}
                delayHide={1}
                delayShow={1000}
            >
                <span
                    className={className ? className + ' ' + refreshClass : refreshClass}
                    onClick={(e) => {
                        if (!disabled) {
                            if (onClick && typeof onClick === "function") {
                                onClick(e);
                            }
                        }

                    }}
                    {...others}
                ></span>
            </Tooltip>
        );
    }

}